import { createStore } from 'vuex'
import main from './modules/main';

const store = createStore({
    modules: {
        main,
    },
    state: {
        verificationCode: '',
        verificationType: '',
        verificationValue: '',
    },
    mutations: {
        SET_VERIFICATION_CODE(state, code) {
            state.verificationCode = code;
        },
        SET_VERIFICATION_TYPE(state, type) {
            state.verificationType = type;
        },
        SET_VERIFICATION_VALUE(state, value) {
            state.verificationValue = value;
        },
    },
    actions: {
        saveVerificationData({ commit }, { code, type, value }) {
            commit('SET_VERIFICATION_CODE', code);
            commit('SET_VERIFICATION_TYPE', type);
            commit('SET_VERIFICATION_VALUE', value);
        },
    },
})

export default store;